// @flow

import * as React from 'react';

import type { TranslatorProps } from '@gandi/translate';
import { Base, Hide, Text } from '@gandi/ui';
import {
  ListCell,
  ListCellGroup,
  ListIcon,
  ListItem,
  ListRow,
  TitleCell,
} from '@gandi/ui/deprecated';

import styles from './Server.scss';

export type ServerProps = {
  cores: number, // eslint-disable-line react/no-unused-prop-types
  hostname: string,
  image: string,
  ipv4: number, // eslint-disable-line react/no-unused-prop-types
  ipv6: number, // eslint-disable-line react/no-unused-prop-types
  memory: number, // eslint-disable-line react/no-unused-prop-types
  storage: number, // eslint-disable-line react/no-unused-prop-types
};

type Props = {
  ...ServerProps,
  price: number,
  currency: string,

  template: string,
  translator: TranslatorProps,
  ...
};

type Translations = {
  [key: string]: (nb: number) => string,
  ...
};

class Server extends React.Component<Props> {
  translations: Translations;

  constructor(props: Props) {
    super(props);
    const { translator } = this.props;

    this.translations = {
      cores: count => translator.__('%(count)s CPU cores', { count }),
      ipv4: count =>
        count > 0 ? translator.__('%(count)s IP v4', { count }) : '',
      ipv6: count =>
        count > 0 ? translator.__('%(count)s IP v6', { count }) : '',
      memory: count =>
        count >= 1024
          ? translator.__('%(count)s GB of RAM', { count: count / 1024 })
          : translator.__('%(count)s MB of RAM', { count }),
      storage: count => translator.__('%(count)s GB of storage', { count }),
    };
  }

  render(): React.MixedElement {
    const { __, formatPrice } = this.props.translator;

    return (
      <div>
        <ListRow separatorBottom>
          <ListItem>
            <TitleCell>{__('New resources')}</TitleCell>
          </ListItem>
        </ListRow>
        <ListRow>
          <ListItem>
            <ListIcon name="hosting">{__('Cloud')}</ListIcon>
            <ListCellGroup>
              <ListCell className={styles.server}>
                <Base marginTop="xsmall">
                  <Text weight="semibold">{this.props.hostname}</Text>
                  <Text
                    color="light"
                    display="block"
                    size="small"
                    weight="semibold"
                  >
                    {this.props.template} - {this.props.image}
                  </Text>
                  <Hide until="xsm">
                    <div className={styles.specifications}>
                      {['cores', 'ipv6', 'ipv4', 'memory', 'storage']
                        .filter(key => !!this.translations[key])
                        .filter(
                          key => !!this.translations[key](this.props[key]),
                        )
                        .map(key => (
                          <Text
                            color="light"
                            key={key}
                            size="small"
                            tagName="div"
                            weight="semibold"
                          >
                            {this.translations[key](this.props[key])}
                          </Text>
                        ))}
                    </div>
                  </Hide>
                </Base>
              </ListCell>
              <ListCell type="secondary">
                {__('30-day Cost %(consumption)s', {
                  consumption: formatPrice(
                    this.props.price,
                    this.props.currency,
                  ),
                })}
              </ListCell>
            </ListCellGroup>
          </ListItem>
        </ListRow>
      </div>
    );
  }
}

export default Server;
